<template>
  <b-modal
    id="document-types-form-modal"
    hide-footer
    size="lg"
    title="Create new document type"
    @hidden="$emit('hidden')"
    @show="modalShown"
  >
    <b-form @submit.prevent="submit">
      <validation-observer ref="formRef">
        <b-card>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Name English"
                rules="required"
              >
                <b-form-group
                  label="Name English"
                  label-for="tag-name-en"
                >
                  <b-form-input
                    id="tag-name-en"
                    v-model="formData.name.en"
                    placeholder="English Name"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Name Arabic"
                rules="required"
              >
                <b-form-group
                  label="Name Arabic"
                  label-for="tag-name-ar"
                >
                  <b-form-input
                    id="tag-name-ar"
                    v-model="formData.name.ar"
                    placeholder="Arabic Name"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Resource Type"
                label-for="resource-type"
              >
                <v-select
                  id="resource-type"
                  v-model="formData.resourceType"
                  :options="resourceTypes"
                  :reduce="val => val.value"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Required"
                label-for="required"
              >
                <b-form-checkbox
                  id="required"
                  v-model="formData.required"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              class="d-flex align-items-center justify-content-center"
            >
              <b-button
                block
                variant="primary"
                type="submit"
                :disabled="submitting"
              >
                <b-spinner
                  v-if="submitting"
                  small
                />
                <span v-else>Save</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BForm,
    BFormCheckbox,
    BFormInput,
    vSelect,
    BSpinner,
    ValidationProvider,
    BButton,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    documentType: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const formRef = ref(null)
    const resourceTypes = [
      {
        label: 'Business',
        value: 'BUSINESS',
      },
      {
        label: 'Branch',
        value: 'BRANCH',
      },
    ]
    const formData = ref({
      name: {
        en: '',
        ar: '',
      },
      required: false,
      resourceType: 'BUSINESS',
    })

    const submitting = ref(false)
    const submit = async () => {
      const res = await formRef.value.validate()
      if (!res) return
      try {
        submitting.value = true
        if (props.documentType) {
          await ctx.root.$store.dispatch('business/updateDocumentType', {
            payload: formData.value,
            documentTypeId: props.documentType.id,
          })
        } else {
          await ctx.root.$store.dispatch('business/createDocumentType', formData.value)
        }
        ctx.root.$bvModal.hide('document-types-form-modal')
        ctx.emit('document-type-created')
      } finally {
        submitting.value = false
      }
    }

    const modalShown = () => {
      if (props.documentType) {
        formData.value.name = { ...props.documentType.name }
        formData.value.required = props.documentType.required
        formData.value.resourceType = props.documentType.resourceType
      }
    }
    return {
      resourceTypes,
      required,
      formData,
      modalShown,
      submit,
      submitting,
      formRef,
    }
  },
}
</script>

<style>

</style>
